module.exports = __webpack_public_path__ + "img/2.89d16ad5.png";